import { createMemo } from '@packages/react';
import { get, orderBy } from 'lodash';
import React from 'react';

interface OrderByProps {
    by: string;
    direction: 'asc' | 'desc';
    children?: any;
    transformer?: (value: any, props: { [key: string]: any }) => any;
}

export const OrderBy = createMemo<OrderByProps>(
    (props): any => {
        const children = React.Children.toArray(props.children);
        const transformer = props.transformer || ((value) => value);

        return orderBy(children, (item: any) => transformer(get(item.props, props.by), item.props), props.direction);
    },
    {
        displayName: 'OrderBy',
    },
);
